module.exports = __webpack_public_path__ + "static/media/floor.3261bcc2.svg";